<template>
  <div class="loader loader-bg">
    <div class="product">
      <div class="product-avatar">
        <GFMP />
      </div>
      <div class="product-body">
        <div v-for="i in 3" :key="i" class="text">
          <GFMP />
        </div>
        <div class="rating">
          <GFMP v-for="i in 5" :key="i" />
        </div>
        <div class="text">
          <GFMP />
        </div>
      </div>
    </div>
    <div class="product-insight">
      <div class="rating-detail">
        <GFMP v-for="i in 3" :key="i" />
      </div>
      <div class="expert-review">
        <div class="profile">
          <div class="profile-avatar">
            <GFMP />
          </div>
          <div class="profile-info">
            <GFMP v-for="i in 2" :key="i" />
          </div>
        </div>
        <div class="expert-review-details">
          <GFMP v-for="i in 2" :key="i" />
        </div>
      </div>
    </div>
    <div class="review">
      <div class="review-filter">
        <div class="review-filter-tab">
          <GFMP v-for="i in 4" :key="i" />
        </div>
      </div>
      <div class="review-personalized">
        <div class="skin-list">
          <div v-for="skin in 4" :key="skin" class="skin-item">
            <GFMP v-for="i in 2" :key="i" />
          </div>
        </div>
      </div>
      <ExpertReviewLoader />
    </div>
    <div class="product-recommendation">
      <ListProductSlideLoader :per-page-custom-props="2" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-detail-loader',
  components: {
    ExpertReviewLoader: () => import('@/components/global/loader/expert-review-loader'),
    ListProductSlideLoader: () => import('@/components/global/loader/list-product-slide-loader'),
  },
};
</script>

<style lang="scss" scoped>
$defaultSpacing: 8px;
$defaultGrey: #f6f6f6;
$defaultDarkGrey: #e6e6e6;

@mixin fmpCircle {
  :first-child {
    border-radius: 50%;
    height: 20px;
  }
}

@mixin fmpRounded {
  :first-child {
    border-radius: 8px;
  }
}

@mixin fmpTextLarge {
  :first-child {
    height: 20px;
  }
}

@mixin fmpTextMedium {
  :first-child {
    height: 16px;
  }
}

@mixin fmpTextSmall {
  :first-child {
    height: 12px;
  }
}

@mixin flexColumn {
  display: flex;
  flex-direction: column;
}

@mixin box($isHorizontal: false) {
  @if ($isHorizontal == false) {
    @include flexColumn();
  }

  display: flex;
  gap: 16px;
  padding: 16px;
  background-color: white;
  width: 100%;
}

@function getRandomWidth($min: 30, $max: 100) {
  @return percentage(($min + (random() * ($max - $min))) / 100);
}

.loader {
  @include flexColumn();
  gap: 16px;

  &-bg {
    background-color: $defaultGrey;
  }

  .FMP_WRAPPER {
    @include fmpRounded();
    :first-child {
      line-height: 0;
      min-height: 16px;
    }
  }

  .product {
    @include box(true);

    &-avatar {
      flex-basis: 35%;

      .FMP_WRAPPER :first-child {
        aspect-ratio: 1/1;
      }
    }

    &-body {
      @include flexColumn();
      gap: $defaultSpacing;
      flex-grow: 1;

      @for $i from 1 through 6 {
        :nth-child(#{$i}).text .FMP_WRAPPER {
          @include fmpTextSmall();
          width: getRandomWidth(40);
        }
      }

      .rating {
        display: flex;
        gap: $defaultSpacing;

        .FMP_WRAPPER {
          @include fmpCircle();
        }
      }
    }
  }

  .product-insight {
    @include box();
    .rating-detail {
      display: flex;
      gap: 16px;
      align-items: center;
      background-color: $defaultGrey;
      padding: 16px;

      :first-child.FMP_WRAPPER {
        @include fmpCircle();
      }

      :nth-child(2).FMP_WRAPPER,
      :nth-child(3).FMP_WRAPPER {
        @include fmpTextSmall();
        flex-grow: 1;
      }
    }

    .expert-review {
      @include flexColumn();
      gap: 16px;
      padding: 16px;
      background-color: $defaultGrey;

      .profile {
        display: flex;
        gap: $defaultSpacing;
        align-items: center;

        &-avatar .FMP_WRAPPER {
          :first-child {
            width: 32px;
            aspect-ratio: 1/1;
          }
        }

        &-info {
          @include flexColumn();
          gap: 4px;
          flex-grow: 1;

          .FMP_WRAPPER {
            @include fmpTextSmall();
          }

          @for $i from 1 through 2 {
            :nth-child(#{$i}).FMP_WRAPPER {
              width: getRandomWidth(30, 60);
            }
          }
        }
      }

      &-details {
        @include flexColumn();
        gap: $defaultSpacing;

        .FMP_WRAPPER {
          @include fmpTextSmall();
        }

        @for $i from 1 through 2 {
          :nth-child(#{$i}).FMP_WRAPPER {
            width: getRandomWidth(40);
          }
        }
      }
    }
  }

  .review {
    @include box();
    gap: 24px;

    &-filter {
      &-tab {
        display: flex;
        gap: 32px;
        padding: 16px 0;
        border-bottom: 1px solid $defaultGrey;

        .FMP_WRAPPER {
          @include fmpTextMedium();
          width: 48px;
        }
      }

      &-selection {
        display: flex;
        gap: 32px;
        padding: 32px 0;

        .FMP_WRAPPER {
          @include fmpTextSmall();
          width: 88px;
        }
      }
    }

    &-personalized {
      @include flexColumn();
      gap: 24px;

      &-title .FMP_WRAPPER {
        @include fmpTextSmall();
        width: 30%;
      }

      .skin {
        &-list {
          display: flex;
          gap: 16px;
        }

        &-item {
          display: flex;
          gap: 4px;
          align-items: center;
          flex-grow: 1;

          :first-child.FMP_WRAPPER {
            @include fmpCircle();
          }

          :last-child.FMP_WRAPPER {
            @include fmpTextSmall();
            flex-grow: 1;
          }
        }
      }
    }

    &-list {
      padding: 24px;
      background-color: white;
    }
  }

  .product-recommendation {
    @include box();
  }
}
</style>
